import React from 'react';
import { useTranslation } from 'react-i18next';
import { ApplicationElementType, getBaseBCItemForType } from '../../../components/DetailWindow/breadCrump.helpers';
import { ProPage } from '../../../components/Page/Page';
import { NotImplemented } from '../../../modules/ProErrorPage/NotImplemented';

export const TeamStatusReportPage = () => {
    const { t } = useTranslation();
    return (
        <ProPage
            breadCrump={getBaseBCItemForType([ApplicationElementType.ProjectMan], t)}
            name={t('navigation.projectMan.integrationMan')}
        >
            <NotImplemented message={t('navigation.projectMan.integrationMan')} />
        </ProPage>
    );
};
